module.exports = Vuex;


//////////////////
// WEBPACK FOOTER
// external "Vuex"
// module id = 126
// module chunks = 1